function HistoricalForcast() {
    return (
      <h1>Historical Forcast</h1>
    );
  }
  
  export default HistoricalForcast;